

















































import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
		/** Use column for VLayout */
		column: {
			type: Boolean,
			default: false
		},
		/** The title of the panel */
		titleText: {
			type: String,
			default: undefined
		},
		titleCss: {
			type: String,
			default: undefined
		},
		/** Display the help button */
		helpBtn: {
			type: Boolean,
			default: false
		},
		id: {
			type: String,
			default: 'nature'
		},
		/** Display the warning pictogramme */
		warning: {
			type: Boolean,
			default: false
		},
		layoutCss: {
			type: String,
			default: 'py-3 px-3'
		},
		panelLine: {
			type: Boolean,
			default: true
		},
		responsive: {
			type: Boolean,
			default: false
		}
	}
});

/** Panel component */
@Component
export default class Panel extends Props {
	mounted() {
		this.$el.addEventListener('focus', () => {
			this.$emit('panel:focus', this);
		}, true);
	}
}
